import { Chains, ChainDefinition } from '@wharfkit/session';

/* Supported Chain */
const chains = {
    'production': {
        'telos': Chains.Telos
    },
    'development': {
        // Greymass on Testnet doesn't support read_only transactions
        'telos': ChainDefinition.from({
            id: '1eaa0824707c8c16bd25145493bf062aecddfeb56c736f6ba6397f3195f33c9f',
            name: 'Telos (Testnet)',
            url: 'https://testnet.telos.caleos.io'
        }),
    }
};

/* EVM Blockchains Config */
const evmBlockchains = {
    'production': {
        'telos': {
            name: 'Telos EVM Mainnet',
            chainID: 40, // 0x28
            nativeCurrency: {name: 'TLOS', decimals: 18, symbol: 'TLOS'},
            rpcURL: new URL('https://mainnet.telos.net/evm'),
            explorerURL: new URL('https://teloscan.io'),
            lzEndpoint: {
                id: 30199,
                address: '0x1a44076050125825900e736c501f859c50fe728c'
            }
        },
        'ethereum': {
            name: 'Ethereum',
            chainID: 1, // 0x1
            nativeCurrency: {name: 'Ether', decimals: 18, symbol: 'ETH'},
            rpcURL: new URL('https://etherscan.io'),
            explorerURL: new URL('https://etherscan.io'),
            lzEndpoint: {
                id: 30101,
                address: '0x1a44076050125825900e736c501f859c50fe728c'
            }
        },
        'bsc': {
            name: 'BNB Chain',
            chainID: 56, // 0x38
            nativeCurrency: {name: 'BNB', decimals: 8, symbol: 'BNB'},
            rpcURL: new URL('https://rpc.ankr.com/bsc'),
            explorerURL: new URL('https://bscscan.com'),
            lzEndpoint: {
                id: 30102,
                address: '0x1a44076050125825900e736c501f859c50fe728c'
            }
        },
        'avalanche': {
            name: 'Avalanche',
            chainID: 43114, // 0xa86a
            nativeCurrency: {name: 'Avax', decimals: 18, symbol: 'AVAX'},
            rpcURL: new URL('https://api.avax.network/ext/bc/C/rpc'),
            explorerURL: new URL('https://snowtrace.io'),
            lzEndpoint: {
                id: 30106,
                address: '0x1a44076050125825900e736c501f859c50fe728c'
            }
        },
        'polygon': {
            name: 'Polygon',
            chainID: 137, // 0x89
            nativeCurrency: {name: 'Matic', decimals: 18, symbol: 'MATIC'},
            rpcURL: new URL('https://polygon-rpc.com'),
            explorerURL: new URL('https://polygonscan.com'),
            lzEndpoint: {
                id: 30109,
                address: '0x1a44076050125825900e736c501f859c50fe728c'
            }
        },
        'arbitrum': {
            name: 'Arbitrum One',
            chainID: 42161, // 0xa4b1
            nativeCurrency: {name: 'Ether', decimals: 18, symbol: 'ETH'},
            rpcURL: new URL('https://arbitrum.llamarpc.com'),
            explorerURL: new URL('https://arbiscan.io'),
            lzEndpoint: {
                id: 30110,
                address: '0x1a44076050125825900e736c501f859c50fe728c'
            }
        },
        'optimism': {
            name: 'OP Mainnet',
            chainID: 137, // 0x89
            nativeCurrency: {name: 'Ether', decimals: 10, symbol: 'ETH'},
            rpcURL: new URL('https://mainnet.optimism.io'),
            explorerURL: new URL('https://explorer.optimism.io'),
            lzEndpoint: {
                id: 30111,
                address: '0x1a44076050125825900e736c501f859c50fe728c'
            }
        },
        'fantom': {
            name: 'Fantom',
            chainID: 250, // 0xfa
            nativeCurrency: {name: 'Fantom', decimals: 18, symbol: 'FTM'},
            rpcURL: new URL('https://rpcapi.fantom.network'),
            explorerURL: new URL('https://ftmscan.com'),
            lzEndpoint: {
                id: 30112,
                address: '0x1a44076050125825900e736c501f859c50fe728c'
            }
        },
        'dfk': {
            name: 'DFK Chain',
            chainID: 53935, // 0xd2af
            nativeCurrency: {name: 'Jewel', decimals: 18, symbol: 'JWL'},
            rpcURL: new URL('https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc'),
            explorerURL: new URL('https://subnets.avax.network/defi-kingdoms'),
            lzEndpoint: {
                id: 30115,
                address: '0x1a44076050125825900e736c501f859c50fe728c'
            }
        },
        'harmony': {
            name: 'Harmony',
            chainID: 1666600000, // 0x63564c40
            nativeCurrency: {name: 'ONE', decimals: 18, symbol: 'ONE'},
            rpcURL: new URL('https://api.harmony.one'),
            explorerURL: new URL('https://explorer.harmony.one'),
            lzEndpoint: {
                id: 30116,
                address: '0x1a44076050125825900e736c501f859c50fe728c'
            }
        }
    },
    'development': {
        'telos': {
            name: 'Telos EVM Testnet',
            chainID: 41, // 0x29
            nativeCurrency: {name: 'TLOS', decimals: 18, symbol: 'TLOS'},
            rpcURL: new URL('https://testnet15a.telos.net/evm'),
            explorerURL: new URL('https://testnet.teloscan.io'),
            lzEndpoint: {
                id: 40199,
                address: '0x6edce65403992e310a62460808c4b910d972f10f'
            }
        },
        'bsc': {
            name: 'BNB Smart Chain Testnet',
            chainID: 97, // 0x61
            nativeCurrency: {name: 'tBNB', decimals: 18, symbol: 'tBNB'},
            rpcURL: new URL('https://bsc-testnet.publicnode.com'),
            explorerURL: new URL('https://testnet.bscscan.com'),
            lzEndpoint: {
                id: 40102,
                address: '0x6edce65403992e310a62460808c4b910d972f10f'
            }
        },
        'avalanche': {
            name: 'Avalanche Fuji Testnet',
            chainID: 43113, // 0xa869
            nativeCurrency: {name: 'Avax', decimals: 18, symbol: 'AVAX'},
            rpcURL: new URL('https://api.avax-test.network/ext/bc/C/rpc'),
            explorerURL: new URL('https://testnet.snowtrace.io'),
            lzEndpoint: {
                id: 40106,
                address: '0x6edce65403992e310a62460808c4b910d972f10f'
            }
        },
        'polygon': {
            name: 'Polygon Mumbai',
            chainID: 80001, // 0x13881
            nativeCurrency: {name: 'Matic', decimals: 18, symbol: 'MATIC'},
            rpcURL: new URL('https://rpc-mumbai.maticvigil.com'),
            explorerURL: new URL('https://mumbai.polygonscan.com'),
            lzEndpoint: {
                id: 40109,
                address: '0x6edce65403992e310a62460808c4b910d972f10f'
            }
        }
    }
};

/* Explorers Config */
const telosExplorers = {
    'production': new URL('https://explorer.telos.net'),
    'development': new URL('https://explorer-test.telos.net')
};

/* Token Contracts Config */
const tokenContracts = {
    'production': 'simpletokens',
    'development': 'simpletokens'
};

/* Fee Collector Accounts */
const feeCollectorAccounts = {
    'production': 'monkeyizkool',
    'development': 'yourmamaugly'
};

/* Exports */
export const DEFAULT_BLOCKCHAIN = chains[process.env.NODE_ENV]['telos'];
export const EVM_BLOCKCHAINS = evmBlockchains[process.env.NODE_ENV];
export const TELOS_EVM_CHAIN = evmBlockchains[process.env.NODE_ENV]['telos'];
export const TELOS_EXPLORER_URL = telosExplorers[process.env.NODE_ENV];
export const TOKEN_CONTRACT = tokenContracts[process.env.NODE_ENV];
export const FEE_COLLECTOR = feeCollectorAccounts[process.env.NODE_ENV];

export const getEVMChainSlug = function(chainID) {
    const blockchains = Object.entries(EVM_BLOCKCHAINS);

    for (let i = 0; i < blockchains.length; i++) {
        const [slug, chain] = blockchains[i];

        if (chain.chainID === chainID) {
            return slug;
        }
    }
};